import { render } from "./SearchFrs.vue?vue&type=template&id=33740857&scoped=true"
import script from "./SearchFrs.vue?vue&type=script&lang=js"
export * from "./SearchFrs.vue?vue&type=script&lang=js"

import "./SearchFrs.vue?vue&type=style&index=0&id=33740857&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33740857"]])

export default __exports__